//import
import React, { useEffect, useState } from 'react';
import { Card } from 'antd';
import LoadingPage from '../../../Components/LoadingPage/LoadingPage';
import { GetAccountsBySize, GetAllPayments, GetRetreatsBySize } from '../../../api/AdminService';
import { BarChart, DoughnutChart } from '../../../Components/AdminCharts';
import { Chart, registerables } from 'chart.js';
import { UserOutlined, DollarOutlined, BookOutlined } from '@ant-design/icons';

Chart.register(...registerables);

const AdminDashBoard = () => {
    const [loading, setLoading] = useState(false);
    const [Practitioner, setPractitioner] = useState([]);
    const [Monk, setMonk] = useState([]);
    const [Nun, setNun] = useState([]);
    const [Retreat, setRetreat] = useState([]);
    const [Success, setSuccess] = useState([]);
    const [Refund, setRefund] = useState([]);
    const [totalCost, setTotalCost] = useState(0);

    const getAccounts = (size) => {
        try {
            GetAccountsBySize(size).then(res => {
                if (res.status === 200) {
                    const practitioners = res.data.data.filter(account => account.role === 'Practitioner');
                    setPractitioner(practitioners);
                    const monks = res.data.data.filter(account => account.role === 'Monk');
                    setMonk(monks);
                    const nuns = res.data.data.filter(account => account.role === 'Nun');
                    setNun(nuns);
                }
            })
        } catch (err) {
            console.log(err)
        }
    }

    const getRetreats = (size) => {
        try {
            GetRetreatsBySize(size).then(res => {
                if (res.status === 200) {
                    console.log(res.data.data);
                    setRetreat(res.data.data);
                }
            })
        } catch (err) {
            console.log(err)
        }
    }

    const getPayments = () => {
        try {
            GetAllPayments().then(res => {
                if (res.status === 200) {
                    const success = res.data.filter(retreat => retreat.status === 'Success');
                    setSuccess(success)
                    const refund = res.data.filter(retreat => retreat.status === 'Refunded');
                    setRefund(refund)
                    const totalSuccess = success.reduce((acc, payment) => acc + payment.amount, 0);
                    console.log(totalSuccess)
                    const totalRefund = refund.reduce((acc, payment) => acc + payment.amount, 0) * 0.2;
                    const totalAmount = totalSuccess + totalRefund;
                    setTotalCost(totalAmount);
                }
            });
        } catch (err) {
            console.log(err);
        }
    };

    useEffect(() => {
        getAccounts(1000);
        getRetreats(1000);
        getPayments();
    }, []);

    // Sample data for Bar and Doughnut charts
    const barData = {
        labels: ['Practitioners', 'Monk', 'Nun'],
        datasets: [
            {
                label: 'user',
                data: [Practitioner.length, Monk.length, Nun.length],
                backgroundColor: 'rgba(75, 192, 192, 0.6)',
            },
        ],
    };

    const doughnutData = {
        labels: ['Success', 'Refunded'],
        datasets: [
            {
                data: [Success.length, Refund.length],
                backgroundColor: ['#36A2EB', '#FF6384'],
            },
        ],
    };

    return (

        <div
            style={{
                padding: 24,
                minHeight: '96.5vh',
                Width: '100%',
            }}
        >
            <h1 style={{ fontSize: '2.5rem', marginBottom: 16, fontWeight: 'bold', textAlign: 'left', color: '#003366' }}>STATISTICS</h1>
            {loading ? (<LoadingPage />
            ) : (
                <>
                    <div className="card-container" style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 20 }}>
                        <Card title={<span><UserOutlined /> All Practicipations</span>} style={{ width: 300, backgroundColor: '#a0d8ef' }}>
                            <div>{Practitioner.length} users</div>
                        </Card>
                        <Card title={<span><BookOutlined /> All Retreats</span>} style={{ width: 300, backgroundColor: '#ffe6b3' }}>
                            <div>{Retreat.length} courses</div>
                        </Card>
                        <Card title={<span><DollarOutlined /> All Revenues</span>} style={{ width: 300, backgroundColor: '#d1e7dd' }}>
                            <div>{totalCost} $</div>
                        </Card>
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <div style={{ width: '50%', height: 500 }}>
                            <BarChart title={'User Chart'} data={barData} />
                        </div>
                        <div style={{ width: '50%' }}>
                            <DoughnutChart title={'Retreat Chart'} data={doughnutData} />
                        </div>
                    </div>
                </>)}

        </div>
    );
};

export default AdminDashBoard;
